import { render, staticRenderFns } from "./ActProj.vue?vue&type=template&id=6223ec0e&scoped=true&"
import script from "./ActProj.vue?vue&type=script&lang=js&"
export * from "./ActProj.vue?vue&type=script&lang=js&"
import style0 from "./ActProj.vue?vue&type=style&index=0&id=6223ec0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223ec0e",
  null
  
)

export default component.exports